import { useState, useCallback, useEffect } from "react";
import { DetailTotalData } from "src/api/contract/contract-types";
import { ArticleSection } from "src/components/layout/ArticleSection";
import ContractBillingSubjectDetail from "./detailComponent/ContractBillingSubjectDetail";
import ContractBillingSubjectEdit from "./editComponent/ContractBillingSubjectEdit";

/**
 * 계약 및 청구 주체 정보 영역
 * Props
 * detailData
 */
interface ContractBillingSubjectProp {
  detailData: DetailTotalData; //상품 상세 조회 정보
  setData: Function;
}

const ContractBillingSubject = ({ detailData, setData }: ContractBillingSubjectProp) => {
  const [editable, setEditable] = useState(false);
  const [saveFlags, setSaveFlags] = useState(false);
  const [popupState, setPopupState] = useState(false);
  const [editConfrim, setEditConfrim] = useState(false);
  const [commonModals, setCommonModals] = useState<any>({
    message: "",
    title: "",
  });

  return (
    <ArticleSection
      title={"계약 및 청구 주체 정보"}
      isEditable={editable}
      setIsEditable={setEditable}
      onClickSave={() => setSaveFlags(true)}
      popupState={popupState}
      setPopupState={setPopupState}
      editConfrim={editConfrim}
      setEditConfrim={setEditConfrim}
      commonModals={commonModals}
      disabledState={[String(detailData?.contract?.contractStep), String(detailData?.product.productType)]}
      children={
        editable === false ? (
          <ContractBillingSubjectDetail detailData={detailData} />
        ) : (
          <ContractBillingSubjectEdit
            detailData={detailData}
            setData={setData}
            setEditable={setEditable}
            saveFlags={saveFlags}
            setSaveFlags={setSaveFlags}
            popupState={popupState}
            setPopupState={setPopupState}
            setCommonModals={setCommonModals}
            setEditConfrim={setEditConfrim}
          />
        )
      }
    />
  );
};

export default ContractBillingSubject;
